export default {
  getTodasConferencias: state => state.conferencias,
  getConferencia: state => state.conferencia,
}
